import { ColorsPalette } from '../config/colors'

export const getPresetTextColor = preset => {
  return getLuminanceFromColorCode(preset.color)
}

export const getLuminanceFromColorCode = colorCode => {
  if (!colorCode) {
    return null
  }

  const color = (colorCode.charAt(0) === '#') ? colorCode.substring(1, 7) : colorCode

  const r = parseInt(color.substring(0, 2), 16) // hexToR
  const g = parseInt(color.substring(2, 4), 16) // hexToG
  const b = parseInt(color.substring(4, 6), 16) // hexToB

  const uiColors = [r / 255, g / 255, b / 255]
  const c = uiColors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92
    }

    return Math.pow((col + 0.055) / 1.055, 2.4)
  })

  const luminance = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2])

  return (luminance > 0.179) ? ColorsPalette.LIGHT_BLACK : ColorsPalette.WHITE
}

export const applyOpacityToHex = (hex, opacity = 0.6) => {
  if (!hex || hex[0] !== '#' || hex.length !== 7) return hex

  const alpha = Math.round(opacity * 255).toString(16).padStart(2, '0')
  return `${hex}${alpha}`
}

export const colorShade = (col, amt) => {
  col = col.replace(/^#/, '')
  if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2]

  let [r, g, b] = col.match(/.{2}/g);
  ([r, g, b] = [parseInt(r, 16) + amt, parseInt(g, 16) + amt, parseInt(b, 16) + amt])

  r = Math.max(Math.min(255, r), 0).toString(16)
  g = Math.max(Math.min(255, g), 0).toString(16)
  b = Math.max(Math.min(255, b), 0).toString(16)

  const rr = (r.length < 2 ? '0' : '') + r
  const gg = (g.length < 2 ? '0' : '') + g
  const bb = (b.length < 2 ? '0' : '') + b

  return `#${rr}${gg}${bb}`
}

export const hexToRgb = (hex, opacity = null) => {
  const red = parseInt(hex.substring(1, 3), 16)
  const green = parseInt(hex.substring(3, 5), 16)
  const blue = parseInt(hex.substring(5, 7), 16)

  return opacity === null ? `rgb(${red}, ${green}, ${blue})` : `rgba(${red}, ${green}, ${blue}, ${opacity})`
}
